(() => {
  const day = 86400000;
  function addWorkingDays(date, count) {
    const result = new Date(date);
    while (count > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (result.getUTCDay() !== 0 && result.getUTCDay() !== 6) count--;
    }
    return result;
  }
  function updateDelivery() {
    const targets = document.querySelectorAll('[data-td-delivery-range]');
    if (!targets.length) return;
    // Estimate includes terrarium preparation, followed by weekday transit.
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Asia/Kolkata', year: 'numeric', month: 'numeric', day: 'numeric'
    }).formatToParts(new Date());
    const date = Object.fromEntries(parts.map(part => [part.type, part.value]));
    const today = Date.UTC(Number(date.year), Number(date.month) - 1, Number(date.day));
    const min = addWorkingDays(today + day, 2);
    const max = addWorkingDays(today + 3 * day, 5);
    const format = new Intl.DateTimeFormat('en-IN', { timeZone: 'UTC', day: 'numeric', month: 'short' });
    const range = `${format.format(min)} - ${format.format(max)}`;
    targets.forEach(target => { target.textContent = range; });
  }
  updateDelivery();
  document.addEventListener('shopify:section:load', updateDelivery);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) updateDelivery(); });
})();

